import React                     from 'react';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import PagingView                from '../settings/PagingView';
import PagingModel               from '../settings/PagingModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    padding: 0,
    height: 36,
    minHeight: 36,
    flex: '0 0 auto',
  },
  selectIcon: {
    color: 'inherit',
    top: 'calc(50% - 1.5rem)',
    fontSize: '3rem',
    marginRight: '-1rem',
  },
  actionsRoot: {
    color: 'inherit',
  },
});

interface IMainContentFooterPagingProps {
  model: PagingModel;
  hidePageCounts?: boolean;
}

type MainContentFooterPagingProps = WithStyle<ReturnType<typeof styles>, IMainContentFooterPagingProps>;

class MainContentFooterPaging extends React.PureComponent<MainContentFooterPagingProps> {
  constructor(props: MainContentFooterPagingProps) {
    super(props);
  }

  render() {
    const {classes, model, hidePageCounts} = this.props;

    return <PagingView paging={model} className={classes.root} classes={{selectIcon: classes.selectIcon}} actionsClasses={{root: classes.actionsRoot}} hidePageCounts={hidePageCounts} />;
  }
}

export default withStyles<IMainContentFooterPagingProps>(styles, MainContentFooterPaging);
